module.exports = __webpack_public_path__ + "img/circul8-blue.92a0b617.svg";